import script from "./PatientNameAgeReveal.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientNameAgeReveal.vue?vue&type=script&setup=true&lang=js"

import "./PatientNameAgeReveal.vue?vue&type=style&index=0&id=2468cb42&lang=scss&scoped=true"

import exportComponent from "/builds/gu1sQVEd/1/fe-huihui/fed-doctor-helper-ms/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2468cb42"]])

export default __exports__